<div class="breadcrumb">
  <ng-container *ngFor="let breadcrumb of breadcrumbs">
    <a [routerLink]="breadcrumb.url" [hidden]="breadcrumb.hidden">
      {{ breadcrumb.title }}
    </a>
  </ng-container>
</div>